export default {
  USERINFO_REQUEST: 'APP/USER_MGMT/USERINFO_REQUEST',
  USERINFO_SUCCESS: 'APP/USER_MGMT/USERINFO_SUCCESS',
  USERINFO_ERROR: 'APP/USER_MGMT/USERINFO_ERROR',
};
